(() => {
  const single = 55336184611159;
  const packs = { 2: 55336184643927, 3: 55336184676695 };
  const root = window.Shopify?.routes?.root || '/';
  let running = null;
  let pending = Promise.resolve();
  let allowCheckout = false;
  async function normalize() {
    if (running) return running;
    running = (async () => {
      const response = await fetch(root + 'cart.js', { cache: 'no-store' });
      if (!response.ok) throw new Error('Kunde inte läsa varukorgen.');
      const cart = await response.json();
      const item = cart.items.find(i => i.variant_id === single && packs[i.quantity] && !i.selling_plan_allocation && Object.keys(i.properties || {}).length === 0);
      if (!item) return false;
      const pack = packs[item.quantity];
      const existing = cart.items.find(i => i.variant_id === pack && !i.selling_plan_allocation && Object.keys(i.properties || {}).length === 0);
      const updates = { [item.key]: 0, [existing?.key || pack]: (existing?.quantity || 0) + 1 };
      const result = await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
      const updated = await result.json();
      if (!result.ok || updated.errors) throw new Error(updated.description || 'Kunde inte uppdatera paketet.');
      if (updated.items.some(i => i.key === item.key) || !updated.items.some(i => i.variant_id === pack)) throw new Error('Kontrollera ditt paket i varukorgen.');
      return true;
    })().finally(() => { running = null; });
    return running;
  }
  function showError(error) {
    let message = document.getElementById('julglimt-paket-error');
    if (!message) {
      message = document.createElement('p');
      message.id = 'julglimt-paket-error';
      message.setAttribute('role', 'alert');
      document.querySelector('#MainContent')?.prepend(message);
    }
    message.textContent = 'Paketpriset kunde inte uppdateras. Försök igen eller välj paketet på produktsidan.';
    console.warn('[Julglimt paket]', error.message);
  }
  document.addEventListener('shopify:cart:lines-update', event => {
    pending = Promise.all([pending, event.promise || Promise.resolve()]).then(async () => {
      if (await normalize()) window.location.assign(root + 'cart');
    }).catch(showError);
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (allowCheckout || !(form instanceof HTMLFormElement) || event.submitter?.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    try {
      await pending;
      if (await normalize()) { window.location.assign(root + 'cart'); return; }
      allowCheckout = true;
      form.requestSubmit(event.submitter);
    } catch (error) { showError(error); }
  }, true);
  if (window.location.pathname.replace(/\/$/, '').endsWith('/cart')) {
    normalize().then(changed => { if (changed) window.location.reload(); }).catch(showError);
  }
})();
